module.exports = __webpack_public_path__ + "img/1589041049.270e89fc.jpg";